import React from 'react'
import logo from '../../assets/image/logo.png';
import chessimg12 from '../../assets/image/chessimg12.jpeg';

const TheAdvancedCourse = () => {
    return (


        <div>
            <div id="preloader-active">
                <div className="preloader d-flex align-items-center justify-content-center">
                    <div className="preloader-inner position-relative">
                        <div className="preloader-circle"></div>
                        <div className="preloader-img pere-text">
                            <img src={logo} alt="Loading..." />
                        </div>
                    </div>
                </div>
            </div>

        
            <main>

                <div class="slider-area ">
                    <div
                        className="single-slider hero-overly slider-height d-flex align-items-center"
                        style={{
                            backgroundImage: `url('${chessimg12}')`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    >
                        <div class="container">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="hero-cap">
                                        <h2>The Advance Course</h2>
                                        <nav aria-label="breadcrumb">
                                            <ol class="breadcrumb">
                                                <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                                                <li class="breadcrumb-item"><a href="#">Courses</a></li>
                                                <li class="breadcrumb-item"><a href="#">The Advance Course</a></li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />
                <div style={{ marginLeft: '100px' }}>
                    <div class="section-tittle mb-80">
                        <span>All that is included in this course - </span>
                        <h2>THE ADVANCE COURSE</h2>
                    </div>
                    <div class="history-tl-container">
                        <ul class="tl">
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Knowledge of Different Chess Openings from White</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Knowledge of Different Chess Openings from Black</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Windmills</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Decoy</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Deflection</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Draw by Repition</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Passed Pawns</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Zwischenzug</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Smothered Mate</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Overloaded Piece</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Square vacation</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Line opening and closing</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Knight Fork - Level 3</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Double Attack - Level 3</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Skewer - Level 3</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Pin - Level 3</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Discovered checks and attacks - Level 3</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Destroying the defender - Level 3</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Pawn Chains and Islands</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">Conecpt of Triangulation</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">King-Queen v/s King-Rook</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">King-Pawn v/s King-Pawn</div>

                            </li>
                            <li class="tl-item" ng-repeat="item in retailer_history">

                                <div class="item-title">King and two pawns v/s King-Pawn</div>

                            </li>
                        </ul>

                    </div>
                </div>
            </main>

          
            <div id="back-top" style={{ textAlign: 'center' }}>
                <a title="Go to Top" href="#" style={{ display: 'inline-block' }}>
                    <i className="fas fa-level-up-alt"></i>
                </a>
            </div>
            
        </div>

    )
}

export default TheAdvancedCourse